import { IHomepageHeadlineOptionsXP } from "@faire/web-api/indigofair/seo/IHomepageHeadlineOptionsXP";
import { HOMEPAGE_HEADLINE_OPTIONS_240826 } from "@faire/web-api/indigofair/settings/HOMEPAGE_HEADLINE_OPTIONS_240826";

import { useAssignSetting, useSetting } from "./__internal__/useSetting";

export const useSettingHomepageHeadlineOptions =
  (): IHomepageHeadlineOptionsXP =>
    useSetting(
      HOMEPAGE_HEADLINE_OPTIONS_240826,
      IHomepageHeadlineOptionsXP.Bucket.BUCKET_UNKNOWN
    );

export const useAssignSettingHomepageHeadlineOptions = () =>
  useAssignSetting(HOMEPAGE_HEADLINE_OPTIONS_240826);
